import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Accard } from "./accordion_card/accordion_card.component";
import { Divider } from "@mui/material";
import { Chip } from "@mui/material";
import "./accordion_card/accordion.css";

export default function SimpleAccordion(props) {
  return (
    <div>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography
            sx={{
              textAlign: "center",
              fontSize: "h4.fontSize",
              fontFamily: "Montserrat",
            }}
          >
            More Details
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="PERSONAL"
            />
          </Divider>
          <Accard
            header="Personal Information"
            key="Personal Information"
            body={[{ Email : props.name.email },{ Phone : props.name.phone },{ Semester : props.name.semester },{ Section : props.name.section },{ Stream : props.name.stream }]}
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="ACADEMIC"
            />
          </Divider>
          <Accard
            header="Academic Information"
            key="Academic Information"
            body={[{ Tenth_Percentage : props.name.tenthper },{ Twelfth_percentage : props.name.twelfthper },{ Semester : props.name.semester },{ UGCGPA : props.name.UGCGPA },{ PGCGPA : props.name.PGCGPA === "" ? "Not applicable" : props.name.PGCGPA }]}
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="LINKS"
            />
          </Divider>
          <Accard
            header="Links"
            body={[{ LinkedIn : props.name.linkedin },{ Glassdoor : props.name.glassdoor }]}
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="ACTIVITIES"
            />
          </Divider>
          <Accard
            header="Co-Curricular Activities"
            key="Co-Curricular Activities"
            body={props.name.ecc}
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="CLUBS"
            />
          </Divider>
          <Accard 
            header="Clubs"
            body={props.name.clubs} 
            key="Clubs"
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="CERTIFICATIONS"
            />
          </Divider>
          <Accard
            header="Certifications"
            key="Certifications"
            body={props.name.certifications}
          />
          <Divider sx={{ mt: 10, mb: 10 }}>
            <Chip
              sx={{
                fontFamily: "Montserrat",
                bgcolor: "#051d73",
                color: "white",
                fontWeight: "medium",
              }}
              label="PROJECTS"
            />
          </Divider>
          <Accard
            header="Projects and Internships"
            key="Projects and Internships"
            body={props.name.projectsandinternships}
          />
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
